var _circle, _path, _mask, _path2, _path3, _mask2, _path4, _path5, _mask3, _path6, _path7, _path8, _mask4, _path9, _path10, _mask5, _path11, _path12, _mask6, _path13, _path14, _mask7, _path15, _path16, _mask8, _path17, _path18, _mask9, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizedBusinessCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.272,
    cy: 38.272,
    r: 38.272,
    fill: "#EBD28D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9688 18.9688H51.7812V24.2188H18.9688V18.9688Z",
    stroke: "#15585D",
    strokeWidth: 1.44375,
    strokeMiterlimit: 10
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 20.9375H22.25V22.25H20.9375V20.9375Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 20.9375H22.25V22.25H20.9375V20.9375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 20.9375V19.4937H19.4937V20.9375H20.9375ZM22.25 20.9375H23.6938V19.4937H22.25V20.9375ZM22.25 22.25V23.6938H23.6938V22.25H22.25ZM20.9375 22.25H19.4937V23.6938H20.9375V22.25ZM20.9375 20.9375V22.3813H22.25V20.9375V19.4937H20.9375V20.9375ZM22.25 20.9375H20.8062V22.25H22.25H23.6938V20.9375H22.25ZM22.25 22.25V20.8062H20.9375V22.25V23.6938H22.25V22.25ZM20.9375 22.25H22.3813V20.9375H20.9375H19.4937V22.25H20.9375Z",
    fill: "#15585D",
    mask: "url(#path-3-inside-1_8572_16311)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 20.9375H24.875V22.25H23.5625V20.9375Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 20.9375H24.875V22.25H23.5625V20.9375Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 20.9375V19.4937H22.1187V20.9375H23.5625ZM24.875 20.9375H26.3188V19.4937H24.875V20.9375ZM24.875 22.25V23.6938H26.3188V22.25H24.875ZM23.5625 22.25H22.1187V23.6938H23.5625V22.25ZM23.5625 20.9375V22.3813H24.875V20.9375V19.4937H23.5625V20.9375ZM24.875 20.9375H23.4312V22.25H24.875H26.3188V20.9375H24.875ZM24.875 22.25V20.8062H23.5625V22.25V23.6938H24.875V22.25ZM23.5625 22.25H25.0063V20.9375H23.5625H22.1187V22.25H23.5625Z",
    fill: "#15585D",
    mask: "url(#path-5-inside-2_8572_16311)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1875 20.9375H27.5V22.25H26.1875V20.9375Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1875 20.9375H27.5V22.25H26.1875V20.9375Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1875 20.9375V19.4937H24.7437V20.9375H26.1875ZM27.5 20.9375H28.9438V19.4937H27.5V20.9375ZM27.5 22.25V23.6938H28.9438V22.25H27.5ZM26.1875 22.25H24.7437V23.6938H26.1875V22.25ZM26.1875 20.9375V22.3813H27.5V20.9375V19.4937H26.1875V20.9375ZM27.5 20.9375H26.0562V22.25H27.5H28.9438V20.9375H27.5ZM27.5 22.25V20.8062H26.1875V22.25V23.6938H27.5V22.25ZM26.1875 22.25H27.6313V20.9375H26.1875H24.7437V22.25H26.1875Z",
    fill: "#15585D",
    mask: "url(#path-7-inside-3_8572_16311)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 54.4062H18.9688V24.2188H51.7812V40.625",
    stroke: "#15585D",
    strokeWidth: 1.44375,
    strokeMiterlimit: 10
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-4_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 27.5H23.5625V28.8125H22.25V27.5Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 27.5H23.5625V28.8125H22.25V27.5Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 27.5V26.0562H20.8062V27.5H22.25ZM23.5625 27.5H25.0063V26.0562H23.5625V27.5ZM23.5625 28.8125V30.2563H25.0063V28.8125H23.5625ZM22.25 28.8125H20.8062V30.2563H22.25V28.8125ZM22.25 27.5V28.9438H23.5625V27.5V26.0562H22.25V27.5ZM23.5625 27.5H22.1187V28.8125H23.5625H25.0063V27.5H23.5625ZM23.5625 28.8125V27.3687H22.25V28.8125V30.2563H23.5625V28.8125ZM22.25 28.8125H23.6938V27.5H22.25H20.8062V28.8125H22.25Z",
    fill: "#15585D",
    mask: "url(#path-10-inside-4_8572_16311)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-5_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.875 27.5H48.5V28.8125H24.875V27.5Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 27.5H48.5V28.8125H24.875V27.5Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 27.5V26.0562H23.4312V27.5H24.875ZM48.5 27.5H49.9438V26.0562H48.5V27.5ZM48.5 28.8125V30.2563H49.9438V28.8125H48.5ZM24.875 28.8125H23.4312V30.2563H24.875V28.8125ZM24.875 27.5V28.9438H48.5V27.5V26.0562H24.875V27.5ZM48.5 27.5H47.0562V28.8125H48.5H49.9438V27.5H48.5ZM48.5 28.8125V27.3687H24.875V28.8125V30.2563H48.5V28.8125ZM24.875 28.8125H26.3188V27.5H24.875H23.4312V28.8125H24.875Z",
    fill: "#15585D",
    mask: "url(#path-12-inside-5_8572_16311)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-6_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 30.125H23.5625V31.4375H22.25V30.125Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 30.125H23.5625V31.4375H22.25V30.125Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 30.125V28.6812H20.8062V30.125H22.25ZM23.5625 30.125H25.0063V28.6812H23.5625V30.125ZM23.5625 31.4375V32.8813H25.0063V31.4375H23.5625ZM22.25 31.4375H20.8062V32.8813H22.25V31.4375ZM22.25 30.125V31.5688H23.5625V30.125V28.6812H22.25V30.125ZM23.5625 30.125H22.1187V31.4375H23.5625H25.0063V30.125H23.5625ZM23.5625 31.4375V29.9937H22.25V31.4375V32.8813H23.5625V31.4375ZM22.25 31.4375H23.6938V30.125H22.25H20.8062V31.4375H22.25Z",
    fill: "#15585D",
    mask: "url(#path-14-inside-6_8572_16311)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-7_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.875 30.125H45.875V31.4375H24.875V30.125Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 30.125H45.875V31.4375H24.875V30.125Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 30.125V28.6812H23.4312V30.125H24.875ZM45.875 30.125H47.3188V28.6812H45.875V30.125ZM45.875 31.4375V32.8813H47.3188V31.4375H45.875ZM24.875 31.4375H23.4312V32.8813H24.875V31.4375ZM24.875 30.125V31.5688H45.875V30.125V28.6812H24.875V30.125ZM45.875 30.125H44.4312V31.4375H45.875H47.3188V30.125H45.875ZM45.875 31.4375V29.9937H24.875V31.4375V32.8813H45.875V31.4375ZM24.875 31.4375H26.3188V30.125H24.875H23.4312V31.4375H24.875Z",
    fill: "#15585D",
    mask: "url(#path-16-inside-7_8572_16311)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-8_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 32.75H23.5625V34.0625H22.25V32.75Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 32.75H23.5625V34.0625H22.25V32.75Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 32.75V31.3062H20.8062V32.75H22.25ZM23.5625 32.75H25.0063V31.3062H23.5625V32.75ZM23.5625 34.0625V35.5063H25.0063V34.0625H23.5625ZM22.25 34.0625H20.8062V35.5063H22.25V34.0625ZM22.25 32.75V34.1938H23.5625V32.75V31.3062H22.25V32.75ZM23.5625 32.75H22.1187V34.0625H23.5625H25.0063V32.75H23.5625ZM23.5625 34.0625V32.6187H22.25V34.0625V35.5063H23.5625V34.0625ZM22.25 34.0625H23.6938V32.75H22.25H20.8062V34.0625H22.25Z",
    fill: "#15585D",
    mask: "url(#path-18-inside-8_8572_16311)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-9_8572_16311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.875 32.75H48.5V34.0625H24.875V32.75Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 32.75H48.5V34.0625H24.875V32.75Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 32.75V31.3062H23.4312V32.75H24.875ZM48.5 32.75H49.9438V31.3062H48.5V32.75ZM48.5 34.0625V35.5063H49.9438V34.0625H48.5ZM24.875 34.0625H23.4312V35.5063H24.875V34.0625ZM24.875 32.75V34.1938H48.5V32.75V31.3062H24.875V32.75ZM48.5 32.75H47.0562V34.0625H48.5H49.9438V32.75H48.5ZM48.5 34.0625V32.6187H24.875V34.0625V35.5063H48.5V34.0625ZM24.875 34.0625H26.3188V32.75H24.875H23.4312V34.0625H24.875Z",
    fill: "#15585D",
    mask: "url(#path-20-inside-9_8572_16311)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9062 37.3438H26.8438V45.2188H22.9062V37.3438Z",
    stroke: "#15585D",
    strokeWidth: 1.44375,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4688 38.6562H33.4062V45.2188H29.4688V38.6562Z",
    stroke: "#15585D",
    strokeWidth: 1.44375,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0312 37.3438H39.9688V45.2188H36.0312V37.3438Z",
    stroke: "#15585D",
    strokeWidth: 1.44375,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9062 47.8438H39.9688V50.4688H22.9062V47.8438Z",
    stroke: "#15585D",
    strokeWidth: 1.44375,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8125 46.5312C51.6247 46.5312 53.0938 45.0622 53.0938 43.25C53.0938 41.4378 51.6247 39.9688 49.8125 39.9688C48.0003 39.9688 46.5312 41.4378 46.5312 43.25C46.5312 45.0622 48.0003 46.5312 49.8125 46.5312Z",
    stroke: "#15585D",
    strokeWidth: 1.44375,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0312 57.0312H42.5938L43.7094 50.7313C43.8406 50.2063 44.2344 49.7469 44.7594 49.6812L47.8438 49.1562L49.8125 53.75L51.7812 49.1562L54.8 49.6812C55.325 49.7469 55.7844 50.2063 55.85 50.7313L57.0312 57.0312Z",
    stroke: "#15585D",
    strokeWidth: 1.44375,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizedBusinessCard);
export default __webpack_public_path__ + "static/media/customized-business-card.e99dfd2d032c983023df825b1c43725d.svg";
export { ForwardRef as ReactComponent };